@import (reference) '../../../../constants/spacing.module.less';

.modal {
  width: 816px;
}

.modal-body {
  padding: @space-16 @space-16 @space-24;
  min-height: 365px;
}

.content-wrapper {
  gap: @space-12;
}

.header {
  display: flex;
}

.add-item-button {
  height: 40px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid var(--table--border-color--2);
  border-top: none;

  &:hover {
    background: var(--button-light--hover--background-color);
  }

  &:focus-visible {
    background-color: var(--button-light--hover--background-color);
    border: none;
    outline: 1px solid var(--primary--link--text-color--2);
  }
}

.add-item-button-contents {
  display: flex;
  flex-flow: row;
  gap: @space-8;
  align-items: center;
}

.icon {
  height: 14px;
}

.add-item-button-text {
  white-space: nowrap;
}

.instructions {
  align-items: center;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: var(--default--text-color--16);
}

.read-only-instructions {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: var(--default--text-color--16);
}

.read-only-wrapper {
  padding-top: @space-8;
  gap: @space-12;
  border-top: 1px solid var(--table--border-color--2);
}

.order-number {
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  color: var(--default--text-color--16);
}

.read-only-section {
  gap: @space-8;
  border-bottom: 1px solid var(--table--border-color--2);
}
